import {
  containerFluid,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  beramourPrimaryColor,
} from "assets/jss/material-dashboard-pro-react.js";

const headerStyle = (theme) => ({
  appBar: {
    backgroundColor: beramourPrimaryColor,
    boxShadow: "none",
    borderBottom: "0",
    marginBottom: "0",
    position: "absolute",
    width: "100%",
    paddingTop: "10px",
    zIndex: "1029",
    color: whiteColor,
    border: "0",
    borderRadius: "0px",
    padding: "10px 0",
    transition: "all 150ms ease 0s",
    minHeight: "50px",
    display: "block",
  },
  container: {
    ...containerFluid,
    minHeight: "50px",
  },
  flex: {
    flex: 1,
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "20px",
    fontWeight: "bold", // Make text bold
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    paddingTop: "0.625rem",
    paddingBottom: "0.625rem",
    margin: "0 !important",
    letterSpacing: "unset",
    "&:hover,&:focus": {
      background: "transparent",
    },
  },
  primary: {
    backgroundColor: primaryColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow,
  },
  sidebarMinimize: {
    float: "left",
    padding: "0 0 0 15px",
    display: "block",
    color: grayColor[6],
  },
  sidebarMinimizeRTL: {
    padding: "0 15px 0 0 !important",
  },
  sidebarMiniIcon: {
    width: "20px",
    height: "17px",
  },
  // Light icon button for collapsing/expanding the desktop sidebar.
  sidebarToggle: {
    color: whiteColor,
    padding: "8px",
    marginRight: "4px",
    transition: "background-color 150ms ease",
    "&:hover, &:focus-visible": {
      backgroundColor: "rgba(255, 255, 255, 0.15)",
    },
    "& svg": {
      fontSize: "24px",
    },
  },
  // The sidebar already shows the logo on desktop; keep it in the header
  // only on small screens, where the sidebar is a hidden drawer.
  brandLogo: {
    height: "32px",
    marginRight: "8px",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
});

export default headerStyle;
